import { useContext } from "react";
import { Thead, THT, THTS } from "../../components";
import TableContext from "../Provider/TableContext";

function TableHead() {
  const { setOrder = () => {} } = useContext(TableContext);

  return (
    <Thead>
      <THTS txt="Name" field="name" setOrder={setOrder} />
      <THTS txt="Email" field="email" setOrder={setOrder} />
      <THTS txt="Phone" field="Phone" setOrder={setOrder} />
      <THTS txt="Role" field="role_id" setOrder={setOrder} />
      <THTS txt="Status" field="is_active" setOrder={setOrder} />
      <THT txt="Actions" />
    </Thead>
  );
}

export default TableHead;
